import React from "react";
import Button from "@mui/material/Button";

export default function BasicButtons(props) {
  const customSx = { 
    fontSize: '16px'
  };

  if (props.variant == 'contained' && !props.color) {
    customSx.background = 'var(--mui-palette-primary-button)',
    customSx.border = '1px solid var(--mui-palette-primary-button)',
    customSx['&:hover'] = {
      border: '1px solid var(--mui-palette-primary-dark)'
    };
  }

  return (
    <Button
      type={props.type}
      variant={props.variant}
      onClick={props.onClick}
      value={props.fieldValue}
      name={props.name}
      id={props.id}
      fullWidth={props.fullWidth}
      endIcon={props.endIcon}
      startIcon={props.startIcon}
      size={props.size || "small"}
      className={props.className}
      sx={{ ...customSx, ...props.sx }}
      style={props.style}
      disabled={props.disabled}
      color={props.color}
      
    >
      {props.placeholder}
    </Button>
  );
}
